import { View, Text, TouchableHighlight, TouchableOpacity } from 'react-native';
import { Card, Icon } from 'react-native-elements';
import lodash from 'lodash';
import styles from '../zonecarousel/styles';
import ExploreImage from '../exploreimage';
import React from 'react';
import {
  FullCategory,
  FullThumbtackCategory,
  Provider,
  // ThumbtackCategoriesObject,
  ThumbtackHomecare,
} from '../../../api/adserver';

interface RenderItemCardProps {
  item: {
    item: ThumbtackHomecare;
    // item: ThumbtackCategoriesObject;
  };
  onPress: (
    item: FullCategory | FullThumbtackCategory,
    provider?: Provider,
    thumbtackCategoryTapped?: string | undefined,
  ) => void;
  onPressFindMore: (
    item: FullCategory | FullThumbtackCategory,
    provider?: Provider,
    thumbtackCategoryTapped?: string | undefined,
  ) => void;
  thumbtackData: FullThumbtackCategory;
}

const ThumbtackRenderItem: React.FC<RenderItemCardProps> = ({
  item: data,
  onPress,
  onPressFindMore,
  thumbtackData,
}) => {
  const { item } = data;
  const listLength = 4;
  let imageUri = lodash.get(item, 'imageURL', undefined);
  if (!imageUri) {
    imageUri = lodash.get(item, 'hero_image.url', undefined);
  }
  if (!item) {
    return null;
  }
  if (item.id < listLength) {
    return (
      <Card containerStyle={[styles.slideContainer]}>
        <TouchableOpacity
          onPress={() => {
            onPressFindMore(
              thumbtackData,
              Provider.Thumbtack,
              item.categoryDisplayName,
            );
          }}
        >
          <ExploreImage uri={imageUri} style={styles.advertImage} />
        </TouchableOpacity>
        <View style={styles.slideTextContainer}>
          {item.categoryDisplayName && (
            <Text style={[styles.slideText, styles.slideTextLarge]}>
              {item.categoryDisplayName}
            </Text>
          )}
        </View>
      </Card>
    );
  } else {
    const onViewMore = null;
    const arrowSize = 26;
    const arrowName = 'arrow-forward';

    return (
      <Card containerStyle={[styles.slideContainer]}>
        <TouchableOpacity
          onPress={() => {
            if (onPressFindMore) {
              onPressFindMore(thumbtackData, Provider.ThumbtackCategory);
            }
          }}
        >
          <View style={styles.advertViewMoreSlideContainer}>
            <View style={[styles.viewMoreSlide]}>
              <Icon
                tvParallaxProperties={null}
                name={arrowName}
                size={arrowSize}
                style={styles.viewMoreArrow}
                iconStyle={styles.iconBase}
              />
              <Text>Find More</Text>
            </View>
          </View>
        </TouchableOpacity>
      </Card>
    );
  }
};

export default ThumbtackRenderItem;
